module.exports = __webpack_public_path__ + "static/media/jeffrey-felizzola.b763516c.png";